module.exports = __webpack_public_path__ + "static/media/silverBgDark.59839242.png";